import { sortingToteIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

const ResolveSortingToteByScanResult_ = z.discriminatedUnion("status", [
  z.object({
    status: z.literal("ok"),
    sortingToteId: sortingToteIdFormat.schema,
    toteName: z.string(),
  }),
  z.object({ status: z.literal("unrecognized") }),
]);
export type ResolveSortingToteByScanResult = z.infer<
  typeof ResolveSortingToteByScanResult_
>;

export const resolveSortingToteByScan = {
  name: "resolveSortingToteByScan" as const,
  input: z.object({ scannedTote: z.string().min(1) }),
  output: z.object({ result: ResolveSortingToteByScanResult_ }),
};
